<script lang="ts">
    import { onDestroy } from 'svelte'

    import { tmpToken } from 'wdom/services/stream'

    import TokenProgress from './TokenProgress.svelte'

    interface Props {
        href: string
        class?: string
        noDisplay?: boolean
        target?: string
        children: any
    }

    let { href, class: classes = '', noDisplay = false, target, children }: Props = $props()

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    let effHref = $derived.by(() => {
        const questionPos = href.search(/\?/)
        if (questionPos >= 0) {
            return `${href}&hydria-token=${$tmpToken}`
        }
        return `${href}?hydria-token=${$tmpToken}`
    })

    let isButton = $derived(classes.search(/btn/) >= 0)
</script>

<style>
    .c-progress-container {
        display: inline-block;
        vertical-align: center;
        --tokprog-outer-w: 1.1454753723em;
        --tokprog-outer-diff: 2px;
        --tokprog-font-size: 0.5727376862em;
        /* --tokprog-outer-w: 1rem;
        --tokprog-outer-diff: 4px;
        --tokprog-font-size: 0.5rem; */
    }
    .circular-progress {
        width: var(--tokprog-outer-w);
        height: var(--tokprog-outer-w);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .inner-circle {
        position: absolute;
        border-radius: 50%;
        background-color: var(--bs-card-bg);
        width: calc(var(--tokprog-outer-w) - var(--tokprog-outer-diff));
        height: calc(var(--tokprog-outer-w) - var(--tokprog-outer-diff));
    }
    .remaining {
        position: relative;
        font-size: var(--tokprog-font-size);
    }
</style>

<a href={effHref} class={classes} {target}>
    {@render children()}{#if !noDisplay && isButton}
        {' '}<TokenProgress />
    {/if}
</a>
{#if !noDisplay && !isButton}<TokenProgress />{/if}
